import { z } from 'zod';
const S = z.string().nullable();
const N = z.number().nullable();
const T = z
    .union([z.string(), z.object({ value: z.string() })])
    .transform((v) => (typeof v === 'string' ? v : v.value))
    .nullable();
export const ContractorSearchHit = z.object({
    profile_kind: z.enum(['entity', 'credential']),
    profile_id: z.string(),
    authority_id: z.string(),
    display_name: S,
    license_number: S,
    credential_class: S,
    status_normalized: S,
    jurisdiction_state: S,
    source_id: z.string(),
    is_name_match: z.boolean(),
});
export const ContractorSearchResponse = z.object({ results: z.array(ContractorSearchHit) });
export const ContractorEntity = z.object({
    entity_id: z.string(),
    authority_id: z.string(),
    authority_business_id: S,
    entity_name: S,
    business_name_2: S,
    full_business_name: S,
    dba_name: S,
    entity_type: S,
    mailing_address: S,
    city: S,
    county: S,
    state: S,
    postal_code: S,
    country: S,
    phone: S,
    entity_status: S,
    entity_status_normalized: S,
    status_observed_at: T,
    source_id: z.string(),
    source_authority: S,
    snapshot_date: T,
    publisher_as_of: T,
});
export const ContractorCredential = z.object({
    credential_id: z.string(),
    authority_id: z.string(),
    entity_id: S,
    person_id: S,
    license_number: S,
    credential_class: S,
    credential_class_description: S,
    credential_scope: S,
    license_type: S,
    endorsements: z.unknown().nullable(),
    asbestos_registration: S,
    pending_suspension: z.boolean().nullable(),
    bond_flag: z.boolean().nullable(),
    status: S,
    status_normalized: S,
    status_observed_at: T,
    secondary_status: S,
    issue_date: T,
    reissue_date: T,
    effective_date: T,
    expiration_date: T,
    inactivation_date: T,
    reactivation_date: T,
    jurisdiction_state: S,
    source_id: z.string(),
    source_authority: S,
    snapshot_date: T,
    publisher_as_of: T,
});
export const ContractorPerson = z.object({
    person_id: z.string(),
    authority_id: z.string(),
    authority_person_id: S,
    entity_id: S,
    credential_id: S,
    person_name: S,
    first_name: S,
    middle_name: S,
    last_name: S,
    name_suffix: S,
    relationship_type: S,
    relationship_normalized: S,
    title: S,
    county: S,
    effective_date: T,
    end_date: T,
    status: S,
    status_normalized: S,
    status_observed_at: T,
    source_id: z.string(),
    source_authority: S,
    snapshot_date: T,
    publisher_as_of: T,
});
export const ContractorAssurance = z.object({
    assurance_id: z.string(),
    authority_id: z.string(),
    entity_id: S,
    credential_id: S,
    person_id: S,
    assurance_type: S,
    assurance_type_normalized: S,
    coverage_type: S,
    provider_name: S,
    amount: N,
    effective_date: T,
    expiration_date: T,
    cancellation_date: T,
    suspend_date: T,
    status: S,
    status_normalized: S,
    status_observed_at: T,
    source_id: z.string(),
    source_authority: S,
    snapshot_date: T,
    publisher_as_of: T,
});
export const ContractorActivityLink = z.object({
    link_id: z.string(),
    activity_dataset: z.enum(['permits', 'planning']),
    activity_source_id: z.string(),
    activity_key: z.string(),
    jurisdiction_state: S,
    activity_date: T,
    entity_id: S,
    credential_id: S,
    authority_id: S,
    match_method: z.string(),
    match_tier: z.number().int().nullable(),
    match_confidence: z.number(),
    candidate_count: z.number().int(),
    is_ambiguous: z.boolean().nullable(),
    valid_on_activity_date: z.boolean().nullable(),
    temporal_basis: S,
});
export const ContractorObservation = z.object({
    observation_id: z.string(),
    observed_status: S,
    status_observed_at: T,
    map_outcome: S,
    reject_reason: S,
    source_id: z.string(),
    source_authority: S,
    source_url: S,
    snapshot_date: T,
    publisher_as_of: T,
    fetched_at: T,
    mapper_version: S,
});
export const ContractorDetailResponse = z.object({
    profile_kind: z.enum(['entity', 'credential']),
    profile_id: z.string(),
    entity: ContractorEntity.nullable(),
    credentials: z.array(ContractorCredential),
    people: z.array(ContractorPerson),
    assurances: z.array(ContractorAssurance),
    activities: z.array(ContractorActivityLink),
    observations: z.array(ContractorObservation),
});
//# sourceMappingURL=contractor.js.map